<template>
  <div class="user">
    <header-top :headerPosition="false">
      <div slot="title">用户协议</div>
    </header-top>
    <div class="user-wrapper">
      <div class="user-title">特别提示</div>
      <div class="user-content">
        “{{ appName }}”的运营主体成都陌陌科技有限公司（以下简称“我们”或“{{
          appName
        }}”）在此特别提醒您（用户）在注册成为用户之前，请认真阅读本《用户协议》（以下简称“协议”），确保您充分理解本协议中各条款。请您审慎阅读并选择接受或不接受本协议。除非您接受本协议所有条款，否则您无权注册、登录或使用本协议所涉服务。您的注册、登录、使用等行为将视为对本协议的接受，并同意接受本协议各项条款的约束。
        本协议约定“{{ appName }}”与用户之间关于“{{
          appName
        }}”软件服务（以下简称“服务”）的权利义务。“用户”是指注册、登录、使用本服务的个人。本协议可由“{{
          appName
        }}”随时更新，更新后的协议条款一旦公布即代替原来的协议条款，恕不再另行通知，用户可在本网站查阅最新版协议条款。在“{{
          appName
        }}”修改协议条款后，如果用户不接受修改后的条款，请立即停止使用“{{
          appName
        }}”提供的服务，用户继续使用“{{ appName }}”提供的服务将被视为接受修改后的协议。
      </div>
      <div class="user-title">一、账号注册</div>
      <div class="user-content">
        1、用户在使用本服务前需要注册一个“{{ appName }}”账号。“{{
          appName
        }}”账号应当使用手机号码注册或绑定，请用户使用尚未与“{{
          appName
        }}”账号绑定的手机号码，以及未被“{{ appName }}”根据本协议封禁的手机号码。
      </div>
      <div class="user-content">
        2、用户理解并承诺，用户所设置的账号不得违反国家法律法规及”{{
          appName
        }}”的相关规则，用户的账号名称、头像和简介等注册信息及其他个人信息中不得出现违法和不良信息，未经他人许可不得用他人名义（包括但不限于冒用他人姓名、名称、字号、头像等或采取其他足以让人引起混淆的方式）开设账号，不得恶意注册”{{
          appName
        }}”账号（包括但不限于频繁注册、批量注册账号等行为）。用户在账号注册及使用过程中需遵守相关法律法规，不得实施任何侵害国家利益、损害其他公民合法权益，有害社会道德风尚的行为。”{{
          appName
        }}”科技有权对用户提交的注册信息进行审核。
      </div>
      <div class="user-title">二、服务内容</div>
      <div class="user-content">
        1、本服务的具体内容由“{{
          appName
        }}”根据实际情况提供，包括但不限于授权用户通过其账号进行消息聊天、添加好友、加入群组、视频聊天互动等功能及服务。“{{
          appName
        }}”可以对其提供的服务予以变更，且“{{ appName }}”提供的服务内容可能随时变更；
      </div>
      <div class="user-content">
        2、“{{
          appName
        }}”提供的服务包含免费服务与收费服务。用户可以通过付费方式购买收费服务，具体方式为：用户通过支付宝或其他“{{
          appName
        }}”平台提供的付费途径支付一定数额的人民币购买“{{
          appName
        }}”平台的虚拟货币——爱心，然后根据“{{
          appName
        }}”公布的资费标准以爱心购买用户欲使用的收费服务，从而获得收费服务使用权限。对于收费服务，“{{
          appName
        }}”会在用户使用之前给予用户明确的提示，只有用户根据提示确认其同意按照前述支付方式支付费用并完成了支付行为，用户才能使用该等收费服务。支付行为的完成以银行或第三方支付平台生成“支付已完成”的确认通知为准。
      </div>
      <div class="user-title">三、用户个人信息保护</div>
      <div class="user-content">1、“{{ appName }}”与用户一同致力于用户个人信息的保护。</div>
      <div class="user-content">
        2、在使用“{{
          appName
        }}”软件及相关服务的过程中，用户可能需要提供用户的个人信息（包括但不限于用户的电话号码、头像信息、设备信息等），以便“{{
          appName
        }}”向用户提供更好的服务和相应的技术支持。“{{
          appName
        }}”将依法保护用户浏览、修改、删除相关个人信息以及撤回授权的权利，并将运用加密技术、匿名化处理等其他与“{{
          appName
        }}”软件及相关服务相匹配的技术措施及其他安全措施保护用户的个人信息。
      </div>
      <div class="user-content">
        3、“{{ appName }}”重视对未成年人的保护。“{{
          appName
        }}”将依赖用户提供的个人信息判断用户是否为未成年人。任何18岁以下的未成年人均不得注册账号或使用本服务。
      </div>
      <div class="user-content">
        4、更多关于用户个人信息保护的内容，请参看《“{{ appName }}”隐私政策》。
      </div>
      <div class="user-title">四、内容规范</div>
      <div class="user-content">
        1、本条所述内容是指用户使用本服务过程中所发布的任何内容，包括但不限于账号头像、名称、用户宣言等注册信息及认证资料，或文字、视频聊天内容和相关链接页面，以及其他使用账号或本服务所产生的内容。
      </div>
      <div class="user-content">
        2、用户不得利用“{{ appName }}”账号或本服务发布如下法律、法规和政策禁止的内容：
      </div>
      <div class="user-content">
        (1) 反对宪法所确定的基本原则的；
        <br />(2) 危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的； <br />(3)
        损害国家荣誉和利益的； <br />(4) 煽动民族仇恨、民族歧视，破坏民族团结的； <br />(5)
        破坏国家宗教政策，宣扬邪教和封建迷信的； <br />(6)
        散布谣言，扰乱经济秩序和社会秩序，破坏社会稳定的； <br />(7)
        散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的； <br />(8)
        侮辱或者诽谤他人，侵害他人名誉、隐私和其他合法权益的； <br />(9)
        歪曲、丑化、亵渎、否定英雄烈士事迹和精神，以侮辱、诽谤或者其他方式侵害英雄烈士的姓名、肖像、名誉、荣誉的；
        <br />(10) 宣扬恐怖主义、极端主义或者煽动实施恐怖活动、极端主义活动的； <br />(11)
        煽动非法集会、结社、游行、示威、聚众扰乱社会秩序的； <br />(12) 以非法民间组织名义活动的；
        <br />(13)
        不遵守法律法规底线、社会主义制度底线、国家利益底线、公民合法权益底线、社会公共秩序底线、道德风尚底线和信息真实性底线的“七条底线”要求的；
        <br />(14) 含有法律、行政法规、政策禁止的其他内容的信息。
      </div>
      <div class="user-content">
        3、用户不得利用“{{ appName }}”账号或本服务发布如下干扰“{{
          appName
        }}”正常运营，以及侵犯其他用户或第三方合法权益，对网络生态造成不良影响的内容：
      </div>
      <div class="user-content">
        (1) 含有任何性或性暗示的；
        <br />(2) 含有辱骂、恐吓、威胁内容的； <br />(3) 含有骚扰、垃圾广告、恶意信息、诱骗信息的；
        <br />(4) 涉及他人隐私、个人信息或资料的； <br />(5)
        侵害他人名誉权、肖像权、知识产权、商业秘密等合法权利的； <br />(6)
        使用夸张标题，内容与标题严重不符的； <br />(7) 炒作绯闻、丑闻、劣迹等的； <br />(8)
        不当评述自然灾害、重大事故等灾难的； <br />(9) 展现血腥、惊悚、残忍等致人身心不适的；
        <br />(10) 煽动人群歧视、地域歧视等的； <br />(11) 宣扬低俗、庸俗、媚俗内容的； <br />(12)
        可能引发未成年人模仿不安全行为和违反社会公德行为、诱导未成年人不良嗜好等的； <br />(13)
        含有其他干扰本服务正常运营和侵犯其他用户或第三方合法权益内容，对网络生态造成不良影响的信息。
      </div>
      <div class="user-title">五、使用规则</div>
      <div class="user-content">
        1、用户在本服务中或通过本服务所传送、发布的任何内容并不反映或代表，也不得被视为反映或代表“{{
          appName
        }}”的观点、立场或政策，“{{ appName }}”对此不承担任何责任。
      </div>
      <div class="user-content">2、用户不得利用“{{ appName }}”账号或本服务进行如下行为：</div>
      <div class="user-content">
        (1) 提交、发布虚假信息，或盗用他人头像或资料，冒充、利用他人名义的；
        <br />(2) 强制、诱导其他用户关注、点击链接页面或分享信息的； <br />(3)
        虚构事实、隐瞒真相以误导、欺骗他人的； <br />(4)
        利用技术或其他手段实施批量建立、注册、操纵虚假账号，非法交易账号，伪造、虚构业务数据信息等破坏平台运营秩序的；
        <br />(5) 利用“{{ appName }}”账号或本服务从事任何违法犯罪活动的； <br />(6)
        制作、发布与以上行为相关的方法、工具，或对此类方法、工具进行运营或传播，无论这些行为是否为商业目的；
        <br />(7) 其他违反法律法规规定、侵犯其他用户合法权益、干扰“{{ appName }}”正常运营或“{{
          appName
        }}”未明示授权的行为。
      </div>
      <div class="user-content">
        3、用户须对利用“{{
          appName
        }}”账号或本服务传送信息的真实性、合法性、无害性、准确性、有效性等全权负责，与用户所传播的信息相关的任何法律责任由用户自行承担，与“{{
          appName
        }}”无关。
      </div>
      <div class="user-content">
        4、“{{ appName }}”提供的服务中可能包括广告，用户同意在使用过程中显示“{{
          appName
        }}”和第三方供应商、合作伙伴提供的广告。除法律法规明确规定外，用户应自行对依该广告信息进行的交易负责。
      </div>
      <div class="user-content">5、除非“{{ appName }}”书面许可，用户不得从事下列任一行为：</div>
      <div class="user-content">
        (1) 删除软件及其副本上关于著作权的信息；
        <br />
        <br />(2) 对软件进行反向工程、反向汇编、反向编译，或者以其他方式尝试发现软件的源代码；
        <br />
        <br />(3) 对“{{
          appName
        }}”拥有知识产权的内容进行使用、出租、出借、复制、修改、链接、转载、汇编、发表、出版、建立镜像站点等；
        <br />
        <br />(4)
        对软件或者软件运行过程中释放到任何终端内存中的数据、软件运行过程中客户端与服务器端的交互数据，以及软件运行所必需的系统数据，进行复制、修改、增加、删除、挂接运行或创作任何衍生作品，形式包括但不限于使用插件、外挂或非经“{{
          appName
        }}”授权的第三方工具/服务接入软件和相关系统；
        <br />
        <br />(5)
        通过修改或伪造软件运行中的指令、数据，增加、删减、变动软件的功能或运行效果，或者将用于上述用途的软件、方法进行运营或向公众传播，无论这些行为是否为商业目的；
        <br />
        <br />(6) 通过非“{{ appName }}”开发、授权的第三方软件、插件、外挂、系统，登录或使用“{{
          appName
        }}”软件及服务，或制作、发布、传播非“{{ appName }}”开发、授权的第三方软件、插件、外挂、系统。
      </div>
      <div class="user-title">六、虚拟货币</div>
      <div class="user-content">
        1、“{{ appName }}”将在“{{ appName }}”平台发行虚拟货币，即爱心。爱心可用于购买“{{
          appName
        }}”平台的增值服务，包括但不限虚拟礼物服务，除此外，不得用于其他任何用途。该等增值服务的价格均以爱心为单位，具体价格信息将由“{{
          appName
        }}”自行决定并在相关服务页面上显示。
      </div>
      <div class="user-content">
        2、爱心和人民币的兑换比例依用户购买渠道的不同而有不同的兑换比例，具体兑换比例以用户购买爱心相关渠道服务页面显示为准。“{{
          appName
        }}”有权根据运营情况随时变更上述兑换比例，并将在用户购买爱心相关渠道服务页面显示。
      </div>
      <div class="user-content">
        3、用户默认已开通爱心账户，可进行爱心购买（下称“充值”）和消费。
      </div>
      <div class="user-content">
        4、用户可以通支付宝或其他“{{
          appName
        }}”平台提供的充值途径为爱心账户进行充值。用户确认不会以非法方式或者使用非平台所指定的充值途径进行充值,如果用户违规使用非“{{
          appName
        }}”认可的充值途径非法充值/购买爱心，则“{{
          appName
        }}”不保证充值顺利或正确完成，若因此造成用户权益受损，“{{
          appName
        }}”将不会作出任何补偿或赔偿，“{{ appName }}”同时保留随时终止用户“{{
          appName
        }}”账号部分或全部权限、冻结用户的帐户余额、短期或永久封禁用户的账号及/或禁止用户及使用各项充值服务的权利。
      </div>
      <div class="user-content">
        5、用户确认在进行充值前已经仔细确认过自己的账号并仔细选择了相关操作选项，若因用户自身输入账号错误、金额错误、操作不当或不了解充值计费方式等因素造成充错账号、充值金额错误、错选充值种类等情形而损害自身权益的，“{{
          appName
        }}”将不会作出任何补偿或赔偿。
      </div>
      <div class="user-content">
        6、用户确认，爱心属于数字化产品，因其特殊属性不适用《中华人民共和国消费者权益保护法》中有关七天无理由退货条款的约束，爱心一经充值成功，用户账号内的爱心可由用户在本服务中自由使用，除法律法规明确规定外，在任何情况下爱心不能兑换为法定货币，不能转让他人。除法律法规明确规定外，爱心账户充值完成后，“{{
          appName
        }}”不予提供任何爱心退款或逆向兑换服务，请用户根据自己的实际需求购买相应数量的爱心。
      </div>
      <div class="user-content">
        7、如果“{{ appName }}”发现因系统故障或其他任何原因导致的处理错误，无论有利于“{{
          appName
        }}”还是有利于用户，“{{
          appName
        }}”都有权纠正该错误。如果该措施导致用户实际收到的爱心数量少于用户应获得的爱心，则“{{
          appName
        }}”在确认该处理错误后会尽快将差额补足至用户的帐户中。如果该错误导致用户实际收到的爱心数量多于用户应获得的爱心，则无论错误的性质和原因如何，“{{
          appName
        }}”有权从用户的帐户中直接扣除差额。
      </div>
      <div class="user-content">
        8、“{{
          appName
        }}”有权基于交易安全等方面的考虑不时设定或修改涉及交易的相关事项，包括但不限于交易限额、交易次数等。用户了解并确认“{{
          appName
        }}”的前述设定或修改可能对用户的交易产生一定的不便，用户对此没有异议。
      </div>
      <div class="user-content">
        9、“{{
          appName
        }}”有权基于交易安全、运营策略、行业惯例等方面的考虑不时设定或修改涉及交易的相关事项，包括但不限于交易限额、交易次数等。用户了解并确认“{{
          appName
        }}”的前述设定或修改可能对用户的交易产生一定的不便，用户对此没有异议。
      </div>
      <div class="user-content">
        10、为更好的向用户提供产品服务，平台会收集记录用户充值购买爱心并在本服务中使用爱心所产生的数据，包括但不限于用户充值、购买虚拟礼物等产品或服务、发红包及其他在本服务中使用爱心所产生的行为信息，以及用户的账号、背包内未打赏礼物、爱心余额等账号信息。
      </div>
      <div class="user-content">
        11、用户确认，除法律法规明确规定或本协议另有约定外，用户已购买的任何收费服务不能以任何理由退购（即退换成爱心或法定货币）或调换成其他服务。
      </div>
      <div class="user-content">
        12、因用户自身的原因导致“{{
          appName
        }}”无法提供爱心购买服务或提供爱心购买服务时发生任何错误而产生的任何损失或责任，由用户自行负责，包括但不限于：
      </div>
      <div class="user-content">
        (1) 因用户的{{ appName }}账号丢失、被封禁或冻结；
        <br />(2) 用户将密码告知他人导致的财产损失； <br />(3)
        因用户绑定的第三方支付机构账户的原因导致的任何损失或责任； <br />(4)
        其他用户故意或者重大过失或者违反法律法规导致的财产损失。
      </div>
      <div class="user-content">
        13、用户在使用“{{ appName }}”提供的服务时，如出现违反国家法律法规、社会主义道德风尚、本协议约定或其他本平台对用户的管理规定的情形，“{{ appName }}”有权视用户行为的性质及严重程度决定暂时或永久封禁用户的账号。账号封禁后至解禁（如有）前，用户账户上的剩余爱心将被暂时冻结或全部扣除，不可继续用于购买平台上的虚拟产品或服务，同时不予返还用户购买爱心时的现金价值。
      </div>
      <div class="user-content">
        14、用户确认并同意如用户主动注销账号，则用户需在注销前将已充值到账的爱心及/或虚拟礼物收益消耗完毕，如您没有消耗完毕且继续注销账号，则您已充值到账的爱心及/或虚拟礼物收益等视为自动放弃，“{{ appName }}”不予返还相应的现金价值，也不会作出任何补偿。
      </div>
      <div class="user-content">
        15、用户保证用于爱心充值的资金均为用户的合法收入所得，且用户有充分权利按照本协议约定使用，因用户违反本条而产生的任何争议或纠纷，由用户自行处理解决，并承担由此带来的全部责任及法律后果。同时，“{{ appName }}”发现（包括但不限于主动发现、收到第三方投诉或权力机关通知等情形）存在上述事由，有权单方决定限制用户使用全部或部分充值爱心、暂停或终止向用户提供充值服务或对用户的账号采取进一步管理措施；如因此给“{{ appName }}”造成损失的，用户应予以全额赔偿，同时，“{{ appName }}”有权保存相关信息，并向相关执法/司法机构、主管部门报告。
      </div>
      <div class="user-content">
        16、如依据中国税收相关法律法规的规定需要由“{{ appName }}”为您代扣代缴个人所得税的，“{{ appName }}”将在您产生收益当月为您申报并代为扣缴相关税费。
      </div>
      <div class="user-title">七、账户管理</div>
      <div class="user-content">
        1、 “{{ appName }}”账号的所有权归“{{ appName }}”所有，用户完成申请注册手续后，获得“{{
          appName
        }}”账号的使用权，该使用权仅属于初始申请注册人，禁止赠与、借用、租用、转让或售卖。如果“{{
          appName
        }}”发现或者有合理理由认为使用者并非账号初始注册人，为保障账号安全，“{{
          appName
        }}”有权立即暂停或终止向该注册账号提供服务，并有权永久禁用该账号。
      </div>
      <div class="user-content">
        2、用户可以通过“我的”页面来查询、更改、删除、注销“{{
          appName
        }}”账户上的个人资料、注册信息等，但需注意，删除有关信息的同时也会删除用户储存在系统中的文字和图片。用户需承担该风险。
      </div>
      <div class="user-content">
        3、用户有责任妥善保管注册账号信息及账号密码的安全，因用户保管不善可能导致遭受盗号或密码失窃，责任由用户自行承担。用户需要对注册账号以及密码下的行为承担法律责任。用户同意在任何情况下不使用其他用户的账号或密码。在用户怀疑他人使用其账号或密码时，用户同意立即通知“{{
          appName
        }}”。
      </div>
      <div class="user-content">
        4、用户应遵守本协议的各项条款，正确、适当地使用本服务，如因用户违反本协议中的任何条款，“{{
          appName
        }}”在通知用户后有权依据协议中断或终止对违约用户“{{ appName }}”账号提供服务。
      </div>
      <div class="user-content">
        5、用户可以通过“设置”页面里来进行账号注销服务，用户确认注销账号是不可恢复的操作，用户应自行备份与“{{
          appName
        }}”账号相关的信息和数据，用户确认操作之前与“{{
          appName
        }}”账号相关的所有服务均已进行妥善处理。用户确认并同意注销账号后并不代表本“{{
          appName
        }}”账号注销前的账号行为和相关责任得到豁免或减轻，如在注销期间，用户的账号被他人投诉、被国家机关调查或者正处于诉讼、仲裁程序中，“{{
          appName
        }}”有权自行终止用户的账号注销并无需另行得到用户的同意。
      </div>
      <div class="user-title">八、数据储存</div>
      <div class="user-content">
        1、用户在本服务中的相关数据将以加密方式存储在中国境内，“{{
          appName
        }}”在用户删除或注销后，将立即删除数据或按相关法律法规的规定进行匿名化处理，但按相关法律法规或司法机关的要求需要延长保存时间的除外。在延长保存期间内，“{{
          appName
        }}”会以加密形式安全地存储相关数据并进行隔离，直至按相关法律法规或司法机关的要求可以删除或匿名化处理。
      </div>
      <div class="user-content">
        2、如用户停止使用本服务或本服务终止，“{{
          appName
        }}”可以从服务器上永久地删除用户的数据。本服务停止、终止后，“{{
          appName
        }}”没有义务向用户返还任何数据。
      </div>
      <div class="user-title">九、风险承担</div>
      <div class="user-content">
        1、用户理解并同意，“{{ appName }}”仅为用户提供信息分享、传送及获取的平台，用户必须为自己注册账号下的一切行为负责，包括用户所传送的任何内容以及由此产生的任何后果。用户应对“{{ appName }}”及本服务中的内容自行加以判断，并承担因使用内容而引起的所有风险，包括因对内容的正确性、完整性或实用性的依赖而产生的风险。
      </div>
      <div class="user-content">
        如果用户发现任何人违反本协议约定或以其他不当的方式使用本服务，请立即向“{{
          appName
        }}”举报或投诉，“{{ appName }}”将依本协议约定进行处理。
      </div>
      <div class="user-content">
        2、对于所有用户上传的照片、资料、证书及填写的个人信息等，“{{
          appName
        }}”无法保证其内容的正确性、合法性或可靠性，相关责任由上传上述内容的用户单独负责。
      </div>
      <div class="user-content">
        3、用户理解并接受：用户以自己的独立判断从事与交友相关的行为，并独立承担可能产生的责任，“{{
          appName
        }}”不承担任何法律责任。
      </div>
      <div class="user-title">十、知识产权声明</div>
      <div class="user-content">
        1、除本服务中涉及广告的知识产权由相应广告商享有外，“{{
          appName
        }}”在本服务中提供的内容（包括但不限于网页、文字、图片、音频、视频、图表等）的知识产权均归“{{
          appName
        }}”所有，但用户在使用本服务前对自己发布的内容已合法取得知识产权的除外。
      </div>
      <div class="user-content">
        2、除另有特别声明外，“{{
          appName
        }}”提供本服务时所依托软件的著作权、专利权及其他知识产权均归“{{ appName }}”所有。
      </div>
      <div class="user-content">
        3、“{{ appName }}”在本服务中所涉及的图形、文字或其组成，以及其他“{{
          appName
        }}”标志及产品、服务名称（以下统称““{{ appName }}”标识”），其著作权或商标权归“{{
          appName
        }}”所有。未经“{{ appName }}”事先书面同意，用户不得将“{{
          appName
        }}”标识以任何方式展示或使用或作其他处理，也不得向他人表明用户有权展示、使用、或其他有权处理“{{
          appName
        }}”标识的行为。
      </div>
      <div class="user-content">
        4、上述及其他任何“{{ appName }}”或相关广告商依法拥有的知识产权均受到法律保护，未经“{{
          appName
        }}”或相关广告商书面许可，用户不得以任何形式进行使用或创造相关衍生作品。
      </div>
      <div class="user-title">十一、法律责任</div>
      <div class="user-content">
        1、如果“{{ appName }}”发现或收到他人举报或投诉用户违反本协议约定的，“{{ appName }}”有权不经通知随时对用户在平台内产生的数据（包括但不限于用户资料、动态等）进行合规审查，并视情节轻重对违规账号处以包括但不限于警告、拒绝发布、删除内容、限制账号的部分或者全部功能直至终止提供服务、永久关闭账号的措施，且通知用户处理结果。
      </div>
      <div class="user-content">
        2、用户理解并同意，“{{ appName }}”有权依合理判断对违反有关法律法规或本协议规定的行为进行处罚，对违法违规的任何用户采取适当的法律行动，并依据法律法规保存有关信息向有关部门报告等，用户应承担由此而产生的一切法律责任。
      </div>
      <div class="user-content">
        3、用户理解并同意，因用户违反本协议约定，导致或产生的任何第三方主张的任何索赔、要求或损失，包括合理的律师费，用户应当承担赔偿责任。
      </div>
      <div class="user-title">十二、不可抗力及其他免责事由</div>
      <div class="user-content">
        1、用户理解并确认，在使用本服务的过程中，可能会遇到不可抗力等风险因素，使本服务发生中断。不可抗力是指不能预见、不能克服并不能避免且对一方或双方造成重大影响的客观事件，包括但不限于自然灾害如洪水、地震、瘟疫流行和风暴等以及社会事件如战争、动乱、政府行为等。出现上述情况时，“{{
          appName
        }}”将努力在第一时间与相关单位配合，及时进行修复，但是由此给用户或第三方造成的损失，“{{
          appName
        }}”及合作单位在法律允许的范围内免责。
      </div>
      <div class="user-content">
        2、本服务同大多数互联网服务一样，受包括但不限于用户原因、网络服务质量、社会环境等因素的差异影响，可能受到各种安全问题的侵扰，如他人利用用户的资料，造成现实生活中的骚扰；用户下载安装的其它软件或访问的其他网站中含有“特洛伊木马”等病毒，威胁到用户的计算机信息和数据的安全，继而影响本服务的正常使用等等。用户应加强信息安全及使用者资料的保护意识，要注意加强密码保护，以免遭致损失和骚扰。
      </div>
      <div class="user-content">
        3、用户理解并确认，本服务存在因不可抗力、计算机病毒或黑客攻击、系统不稳定、用户所在位置、用户关机以及其他任何技术、互联网络、通信线路原因等造成的服务中断或不能满足用户要求的风险，因此导致的用户或第三方任何损失，“{{
          appName
        }}”不承担任何责任。
      </div>
      <div class="user-content">
        4、用户理解并确认，“{{ appName }}”需要定期或不定期地对“{{
          appName
        }}”平台或相关的设备进行检修或者维护，如因此类情况而造成服务在合理时间内的中断，“{{
          appName
        }}”无需为此承担任何责任，但“{{ appName }}”应事先进行通告。
      </div>
      <div class="user-content">
        5、“{{ appName }}”依据法律法规、本协议约定获得处理违法违规或违约内容的权利，该权利不构成“{{
          appName
        }}”的义务或承诺，“{{ appName }}”不能保证及时发现违法违规或违约行为或进行相应处理。
      </div>
      <div class="user-content">
        6、在任何情况下，“{{
          appName
        }}”均不对任何间接性、后果性、惩罚性、偶然性、特殊性或刑罚性的损害，包括因用户使用“{{
          appName
        }}”或本服务而遭受的利润损失，承担责任（即使“{{
          appName
        }}”已被告知该等损失的可能性亦然）。尽管本协议中可能含有相悖的规定，“{{
          appName
        }}”对用户承担的全部责任，无论因何原因或何种行为方式，始终不超过用户因使用“{{
          appName
        }}”提供的服务而支付给“{{ appName }}”的费用(如有)。
      </div>
      <div class="user-title">十三、服务的变更、中断、终止</div>

      <div class="user-content">
        1、鉴于网络服务的特殊性，用户同意“{{
          appName
        }}”有权随时变更、中断或终止部分或全部的服务（包括收费服务）
      </div>
      <div class="user-content">
        2、如发生下列任何一种情形，“{{
          appName
        }}”有权变更、中断或终止向用户提供的免费服务或收费服务，而无需对用户或任何第三方承担任何责任：
      </div>
      <div class="user-content">
        (1)
        根据法律规定用户应提交真实信息，而用户提供的个人资料不真实、或与注册时信息不一致又未能提供合理证明；
        <br />
        <br />(2) 用户违反相关法律法规或本协议的约定；
        <br />
        <br />(3) 按照法律规定或有权机关的要求；
        <br />
        <br />(4) 出于安全的原因或其他必要的情形。
        <br />
      </div>
      <div class="user-title">十四、其他</div>
      <div class="user-content">
        1、“{{ appName }}”郑重提醒用户注意本协议中免除“{{
          appName
        }}”责任和限制用户权利的条款，请用户仔细阅读，自主考虑风险。
      </div>
      <div class="user-content">
        2、本协议的效力、解释及纠纷的解决，适用于中华人民共和国法律。若用户和“{{
          appName
        }}”之间发生任何纠纷或争议，首先应友好协商解决，协商不成的，用户同意将纠纷或争议提交协议签署地所在的人民法院管辖，本协议签署地为北京市朝阳区。
        <div class="user-content">
          3、本协议的任何条款无论因何种原因无效或不具可执行性，其余条款仍有效，对双方具有约束力。
        </div>
        <div class="user-content">
          4、由于互联网高速发展，您与“{{
            appName
          }}”签署的本协议列明的条款可能并不能完整罗列并覆盖您与“{{
            appName
          }}”所有权利与义务，现有的约定也不能保证完全符合未来发展的需求。因此，“{{
            appName
          }}”隐私权政策等均为本协议的补充协议，与本协议不可分割且具有同等法律效力。如您使用{{
            appName
          }}平台服务，视为您同意上述补充协议。
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
.user-wrapper {
  padding-top: 120px;
  padding: 120px 30px 0 30px;
  width: 690px;
  text-align: left;
}
.user-title {
  margin-bottom: 40px;
  font-family: "PingFangSC-Medium";
  font-size: 30px;
  color: rgb(63, 68, 111);
}
.user-content {
  font-size: 26px;
  color: #3f446f;
  line-height: 41px;
  padding-bottom: 40px;
}
.user {
  background-color: #f6f5fb;
}
</style>
<script>
import HeaderTop from "src/components/HeaderTop.vue";

export default {
  name: "User",
  data() {
    return {
      appName: this.$store.state.appName
    };
  },
  components: {
    "header-top": HeaderTop // 顶部导航组件
  }
};
</script>
